export const environment = {
  production: true,
  apiUrl: 'https://api.myfutureandme.com/api',
  authApiUrl: 'https://api.myfutureandme.com/api/auth'
};



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/mmam/angular/src/environments/environment.ts